import { useCallback, useMemo } from "react";

import * as CLOUD_API from "@skydio/api_util/src/backends/cloud_api";

import MultiSelectFilter from "./MultiSelectFilter";

import type { FC } from "react";
import type { ValueType } from "@skydio/core";
import type { VehicleType } from "@skydio/pbtypes/pbtypes/tools/cloud_api/enums_pb";
import type { BaseProps } from "./SelectFilter";

const { vehicleTypeEnum } = CLOUD_API.modules.vehicles.utils;

type ReadableVehicleType = {
  readableName: string;
  enumValue: string | ValueType<VehicleType.VehicleTypeEnumMap>;
  enumStringName: string;
};

interface Props extends BaseProps {
  placeholder: string;
  onSelect: (value: string[]) => void;
  selectedValues?: string[] | undefined;
  convertParamVariable?: (vehicleTypes: string) => string[];
  disabled?: boolean;
}

const getTypes = () =>
  Object.entries(vehicleTypeEnum)
    .filter(([_, value]) => {
      // The DOCK_XX "vehicles" are not real. Docks are modeled as their own entity.
      // Unclear why these are in the enum, perhaps they started out as vehicles.
      return value != vehicleTypeEnum.DOCK_G27 && value != vehicleTypeEnum.DOCK_G47;
    })
    .map(
      ([key, value]) =>
        ({
          readableName: value,
          enumValue: value,
          enumStringName: key,
        }) as ReadableVehicleType
    );

// TODO (david.taylor): we should refactor this to use Rivet UI select
const MultiVehicleTypeFilter: FC<Props> = ({
  onSelect,
  convertParamVariable,
  placeholder,
  className,
  style,
  paramKey,
  disabled = false,
  selectedValues = undefined,
}) => {
  const data = useMemo(() => getTypes(), []);

  const getKey = useCallback((vehicleType: ReadableVehicleType) => vehicleType.enumStringName, []);
  const getValue = useCallback(
    (vehicleType: ReadableVehicleType) => vehicleType.enumStringName,
    []
  );
  const getTitle = useCallback(
    (vehicleType: ReadableVehicleType) => vehicleType.enumStringName,
    []
  );

  return (
    <MultiSelectFilter<ReadableVehicleType, string>
      onSelect={onSelect}
      className={className}
      style={style}
      disabled={disabled}
      placeholder={placeholder}
      data={data}
      paramKey={paramKey}
      getKey={getKey}
      getValue={getValue}
      getTitle={getTitle}
      convertParamVariable={convertParamVariable}
      showSearch={false}
      setValue={selectedValues}
    />
  );
};

export default MultiVehicleTypeFilter;
